import React, { useContext } from 'react';
import AdhesionAdUnit from '../AdUnit/Adhesion/Adhesion';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

export interface Props {}

const DevpageAdhesionPlacement: React.FC<Props> = () => {
  const { isLoggedIn } = useContext(SessionContext);
  const isMobile = useContext(MobileContext);

  // User
  if (isLoggedIn || isMobile) {
    return null;
  }

  // Anon
  return <AdhesionAdUnit realEstateId="166926a9-15ab-458d-b424-4385d5c9acde" />;
};
DevpageAdhesionPlacement.displayName = 'DevpageAdhesionPlacement';

export default DevpageAdhesionPlacement;
